import React from "react";
import Banner from "./banner/Banner";
import Cricket_Calculated from "./cricket-calculated/Cricket_Calculated";
import Users_Counting from "./users-counting-on-us/Users_Counting_On_Us";
import The_Winning_Edge from "./the-winning-edge/The_Winning_Edge";
import Ready_To_Make_Your_Dream_Team from "./ready-to-make-your-dream-team/Ready-To-Make-Your-Dream-Team";
import Our_Journey from "../about-us/our-journey/Our_Journey";

const Home = () => {
  return (
    <>
      <Banner />
      <Cricket_Calculated />
      <Users_Counting />
      <The_Winning_Edge />
      <Ready_To_Make_Your_Dream_Team />

    </>
  );
};

export default Home;
